import React, {useState} from 'react';

import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useStoreActions, useStoreState } from "easy-peasy";

import Domain from './Domain';


export default function DomainList() {
  const [domain_name, setDomainName] = useState('');
  const [message, setMessage] = useState('');
  const domains = useStoreState(state => state.domains);
  const createDomain = useStoreActions(actions => actions.domains.createDomain);

  const addNewDomain = (e) => {
    e.preventDefault();
    if (domain_name) {
      createDomain(domain_name).then((result) => {
        if (result.success) {
          setMessage("Success!");
        } else {
          setMessage(result.error);
        }
      });
    }
  };

  // FIXME: allow setting default domain

  return (
    <div className="container px-0">
    <div className="row">
      <div className="col">
        <h3>Don't have your own domain? No worries!</h3>
        <p>LINKOLN offers a list of available domains for you to choose from when creating your links.</p>
        <p><strong>Start link’in with Linkoln!</strong></p>

      </div>
    </div>
      <div className="row">
        <div className="col-12">
          <h3>Domains</h3>
          <p>{domains.credits} credits</p>
          <Table striped bordered responsive className="bg-white">
            <thead className="thead-dark">
                <tr><th>Domain</th><th>Status</th><th>&nbsp;</th></tr>
            </thead>
            <tbody>
            {domains.domains &&
              domains.domains.map(domain => (
                <Domain key={domain.domain} domain={domain}/>
              ))
            }
            </tbody>
          </Table>
          <hr/>
        </div>
      </div>
        { domains.credits > 0 && (
      <div className="row">
        <div className="col-12">
          <h3>Redeem credits</h3>
          <p>{domains.credits} credits</p>
          <p>{ message }</p>
          <Form onSubmit={addNewDomain}>
            <Row>
              <Col>Custom Domain:</Col>
            </Row>
            <Row>
              <Col>
                  <Form.Control as="input" onChange={(e) => setDomainName(e.target.value)} value={domain_name}/>
              </Col>
              <Col>
                <Button variant="primary my-3" onClick={addNewDomain}>Add</Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
      )}
    </div>
  );
}
